<template>
    <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save()">
        <v-card>
            <v-card-title>
                <span class="headline">{{ isEdit ? "Edit" : "Add" }} {{ entity.singleTitle }}</span>
            </v-card-title>

            <v-card-text>
                <schema-search-select
                    v-if="isAdd"
                    v-model="selectedTemplateId"
                    entity-key="proposalTemplate"
                    label="Existing Template"
                    :scope="scope"
                    search-when-blank />

                <component
                    :is="getComponent(field)"
                    v-for="(field, index) in visibleFields"
                    :key="field.value"
                    v-model="item[field.key]"
                    :field="field"
                    :scope="scope"
                    :autofocus="index === 0"
                    validate-on-blur
                    @save="save" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <app-button
                    v-if="canDelete"
                    color="error"
                    text
                    @click="deleteItem">
                    Delete
                </app-button>
                <v-spacer />
                <app-button
                    v-if="canCancel"
                    color="secondary"
                    text
                    @click="$emit('cancel')">
                    Cancel
                </app-button>
                <app-button
                    v-if="canSave"
                    type="submit"
                    text
                    :disabled="isSaving">
                    Save
                </app-button>
            </v-card-actions>

            <v-progress-linear v-if="isSaving" indeterminate color="blue" />
        </v-card>
    </v-form>
</template>

<script>
import formMixin from "@/features/schemas/mixins/formMixin";
import {get, save, call} from "@/features/schemas/services/schemaApi";
import SchemaSearchSelect from "@/features/schemas/components/SchemaSearchSelect.vue";

export default {
    components: {
        SchemaSearchSelect
    },
    mixins: [formMixin],
    types: [
        "proposalTemplate"
    ],
    data() {
        return {
            selectedTemplateId: null
        };
    },
    computed: {
        isAdd() {
            return !this.isEdit;
        },
        isDuplicateMode() {
            return this.isAdd && !!this.selectedTemplateId;
        },
        duplicateScope() {
            if (!this.scope) {
                return "global";
            }
            const normalized = this.scope.toLowerCase();
            return normalized.includes("department") ? "department" : "global";
        },
        nameField() {
            return this.fields.find(field => field.key === "name");
        },
        visibleFields() {
            if (this.isDuplicateMode) {
                return this.nameField ? [this.nameField] : [];
            }
            return this.fields;
        }
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.selectedTemplateId = null;
            }
        }
    },
    methods: {
        async save() {
            if (this.isSaving || this.form && !this.form.validate()) {
                return;
            }

            this.isSaving = true;
            try {
                if (this.isDuplicateMode) {
                    const duplicatedTemplateId = await call(
                        "proposalTemplate",
                        "duplicate",
                        {
                            proposalTemplateId: this.selectedTemplateId,
                            newName: this.item.name
                        },
                        this.duplicateScope
                    );
                    this.item = await get(this.entityKey, this.scope, duplicatedTemplateId);
                    this.$emit("input", this.item);
                    return;
                }

                const model = { ...this.item, ...this.fixedValues };
                this.item = await save(this.entityKey, this.scope, model, true);
                this.$emit("input", this.item);
            } finally {
                this.isSaving = false;
            }
        }
    }
};
</script>
